/**
 * name 线索推荐
 * author zhang.yingyu
 * createTime 2019-04-01
 **/
"use strict";
angular.module("keyRecommendModule",[])
    .controller("keyRecommendCtrl",["$scope","$state","$q","trsHttpService",function($scope,$state,$q,trsHttpService){
        initStatus();
        initData();
        /**
         * [initStatus description]初始化状态
         */
        function initStatus(){
            $scope.status={
                isSave:false,
                isShowEditTip:false,
                keyRecommendNav: [
                    {name: "今日热门", value: "keysentiments"},
                    {name: "自定义舆情", value: "customsentiments"},
                    {name: "自定义关联", value: "selfDefinedRelate"},
                ],
                selfDefinedSent: [],
                selfDefinedSentSelect:"",
                choiceKeyWordsArticle:{
                    keysentiments:0,
                    customsentiments:[0,0,0],
                },
                relateCont:"",
                keyCommendTitle:"",
                startAnalysisKeyWord:false,
            };
            $scope.data={};
            $scope.status.keyRecommendNavSelect=$scope.status.keyRecommendNav[0].value;
        };
        /**
         * [initData description]初始化数据
         */
        function initData(){
            requestData("keysentiments");
        };
        /**
         * [requestData description] 获取今日热门数据
         * @return {[type]} [description]
         */
        function requestData(modeid,id) {
            var defer = $q.defer();
            var params = {
                'modelid':modeid,
                'serviceid': 'customsentiment',
                'page_no': 0,
                'page_size': 20,
            };
            if(modeid==="keysentiments"){
                params.flag=1;
            }else if(modeid==="customsentiments"){
               params.id=id;
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
                    $scope.data.keyRecommendData = data.PAGEITEMS;
                    if(data.PAGEITEMS){
                        requestRightRecommend($scope.data.keyRecommendData[0].SID);
                        $scope.status.keyCommendTitle=$scope.data.keyRecommendData[0].DOCTITLE;
                    }
                    defer.resolve(data);
                });
            return defer.promise;
        }
        /**
         * [requestSelfDefinedSentNav description] 获取自定义舆情导航标题
         * @return {[type]} [description]
         */
        function requestSelfDefinedSentNav(){
            var defer = $q.defer();
            var params = {
                'modelid':'customtitles',
                'serviceid': 'customsentiment',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function (data) {
                if(angular.isDefined(data)){
                    $scope.status.selfDefinedSent=data;
                    $scope.status.selfDefinedSentSelect=$scope.status.selfDefinedSent[0].id;
                }
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [keyCommendSelect description] 线索推荐导航切换
         */
        $scope.keyCommendSelect=function(tabType,value){
            $scope.$emit("getTrsHeight");
            $scope.status[tabType]=value;
            $scope.status.isShowEditTip=false;
            initEmptyData();
            if(value==="selfDefinedRelate"){
                $scope.status.startAnalysisKeyWord=true;
                return;
            }
            if(!$scope.status.selfDefinedSentSelect&&value==="customsentiments"){
                requestSelfDefinedSentNav().then(function(data){
                    $scope.keyCommendSelect('selfDefinedSentSelect',data[0].id);
                });
            }else{
                requestData($scope.status.keyRecommendNavSelect,$scope.status.selfDefinedSentSelect);
            }
        };
        /**
         * [emptyData description] 初始化数据
         */
        function initEmptyData(){
            $scope.data.KEYWORDS=[];
            $scope.data.ORG=[];
            $scope.data.PEOPLE=[];
            $scope.status.choiceKeyWordsArticle={
                keysentiments:0,
                customsentiments:[0,0,0],
            };
        };
        /**
         * [startAnalysisKeyWord description] 开始分析跳转
         */
        $scope.startAnalysisKeyWord=function(keywords,org,name){
            var url=$state.href("hotpointatlas" ,{keywords:keywords.join(';'),org:org.join(';'),name:name.join(';'),title:$scope.status.keyCommendTitle});
            window.open(url,"_blank");
        };
        /**
         * [getRightRecommend description] 点击获取右侧线索关键词
         */
        $scope.getRightRecommend=function(type,item,index,pindex,title){
            $scope.status.keyCommendTitle=title;
            $scope.status.sid=item;
            $scope.status.isShowEditTip=false;
            if(type==="keysentiments"){
                $scope.status.choiceKeyWordsArticle[type]=index;
            }else{
                $scope.status.choiceKeyWordsArticle[type][pindex]=index;
            }
            requestRightRecommend(item);
        };
        /**
         * [requestRightRecommend description] 获取右侧线索关键词
         */
        function requestRightRecommend(sid,content){
            var defer = $q.defer();
            var params = {
                'modelid':'textExtract',
                'serviceid': 'leadRecommend',
                "id":sid,
                "content":content,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function (data) {
                if(!data.TITLE){
                    $scope.status.keyCommendTitle=data.TITLE;
                }
                $scope.data.KEYWORDS=getSplitData(data.KEYWORDS);
                $scope.data.ORG=getSplitData(data.ORG);
                $scope.data.PEOPLE=getSplitData((data.PEOPLE));
                $scope.status.startAnalysisKeyWord=($scope.data.KEYWORDS.length===0&&$scope.data.ORG.length===0&&$scope.data.PEOPLE.length===0)?true:false;
                defer.resolve(data);
            });
            return defer.promise;
        };
        /**
         * [getSplitData description] 将字符串按;分割
         */
        function getSplitData(value){
            var arr=[];
            if(!!value){
                arr=value.split(";");
            }
            return arr;
        };
        /**
         *
         */
        $scope.extrackKeywordBtn=function(){
            requestRightRecommend("",$scope.status.relateCont);
        };
        /**
         * [editKeyword description] 编辑关键词
         */
        $scope.editKeyword=function(type){
            if(type==="取消编辑"){
                $scope.data.KEYWORDS= $scope.status.keywords;
                $scope.data.ORG= $scope.status.org;
                $scope.data.PEOPLE= $scope.status.people;
            }else{
                $scope.status.keywords=angular.copy($scope.data.KEYWORDS);
                $scope.status.org=angular.copy($scope.data.ORG);
                $scope.status.people=angular.copy($scope.data.PEOPLE);
            }
            $scope.status.isShowEditTip=!$scope.status.isShowEditTip;
        };
        /**
         * [saveKeyword description] 保存关键词
         */
        $scope.saveKeyword=function(){
            $scope.status.isShowEditTip=false;
        };
    }]);